import { configureStore } from '@reduxjs/toolkit';
import signalRMiddleware from '../middleware/alertsMiddleware';
import navigationMiddleware from '../middleware/navigationMiddleware';
import {
  appSettingsReducer,
  notificationsReducer,
  userReducer,
  i18nReducer,
  chartsReducer,
  accountsReducer,
  alertsReducer,
  tableReducer,
  populationHealthReducer,
  infoPaneReducer,
  orderReducer,
  navigationReducer,
  activePatientReducer,
  userAccountManagementReducer,
  accountEditingReducer,
  instantAssessmentReducer,
  // TEMP: Assessment Performance backport (2026-05-07) — orphan after FSD merge.
  assessmentPerformanceReducer,
} from '../slices';


export default configureStore({
  reducer: {
    appSettings: appSettingsReducer,
    infoPane: infoPaneReducer,
    notifications: notificationsReducer,
    user: userReducer,
    i18n: i18nReducer,
    charts: chartsReducer,
    accounts: accountsReducer,
    alerts: alertsReducer,
    table: tableReducer,
    populationHealth: populationHealthReducer,
    order: orderReducer,
    navigation: navigationReducer,
    activePatient: activePatientReducer,
    userAccountManagement: userAccountManagementReducer,
    accountEditing: accountEditingReducer,
    instantAssessment: instantAssessmentReducer,
    // TEMP: Assessment Performance backport (2026-05-07) — orphan after FSD merge.
    assessmentPerformance: assessmentPerformanceReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false,
  }).concat(signalRMiddleware, navigationMiddleware),
});
